export default "__VITE_ASSET__f79cde07__"